const host = "https://api2.aburafil.com/";

export default host;